import { render, staticRenderFns } from "./TeamVote.vue?vue&type=template&id=ea61b6e6&scoped=true"
import script from "./TeamVote.vue?vue&type=script&lang=js"
export * from "./TeamVote.vue?vue&type=script&lang=js"
import style0 from "./TeamVote.vue?vue&type=style&index=0&id=ea61b6e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea61b6e6",
  null
  
)

export default component.exports